export default __webpack_public_path__ + "static/expirationmanagement-56d0b10bfe35ce4bce2546443aa6901d.svg";